import { render } from "./QuizVaildate.vue?vue&type=template&id=2cdc099b&scoped=true"
import script from "./QuizVaildate.vue?vue&type=script&lang=js"
export * from "./QuizVaildate.vue?vue&type=script&lang=js"

import "./QuizVaildate.vue?vue&type=style&index=0&id=2cdc099b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cdc099b"]])

export default __exports__